import { TherapyTimeInterval } from '@lmt/signal-viewer-ui';
import { useMemo } from 'react';

export type QueryParams = {
  initialIndex: number;
  reportMode: boolean;
  separateWindow: boolean;
  timeIntervalFromQuery: TherapyTimeInterval | null;
};

export const useReadQueryParamsFromLocation = (): QueryParams => {
  return useMemo(() => {
    const params = new URLSearchParams(location.search);

    const rawIndex = params.get('index');
    const parsedIndex = rawIndex ? parseInt(rawIndex, 10) : 0;
    const initialIndex = Number.isNaN(parsedIndex) ? 0 : parsedIndex;

    const rawTimeInterval = params.get('time-interval');
    const validValues = Object.values(TherapyTimeInterval) as string[];

    const timeIntervalFromQuery = validValues.includes(rawTimeInterval ?? '')
      ? (rawTimeInterval as TherapyTimeInterval)
      : null;

    return {
      initialIndex,
      reportMode: params.get('report-mode') === 'true',
      separateWindow: params.get('separate-window') === 'true',
      timeIntervalFromQuery,
    };
  }, [location.search]);
};
